/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
  Col,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import CurrencyInput from 'components/CurrencyInput';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getImssNominas } from 'api/nominas/NominaIMSS';
import { getConfiguracionesSeguroIMSS } from 'api/catalogos/ConfiguracionSeguroIMSS';
import { set } from 'lodash';
import { getSeguridadsociales } from 'api/catalogos/SeguridadSocial';
import percentFormatterNDecimals from 'utils/percentFormatterNdecimals';

const NominasIMSS = ({ data, encabezado }) => {
  const [loading, setLoading] = useState(false);
  // const [ImssNominas, setImssNominas] = useState([]);
  const [seguroIMSS, setSeguroIMSS] = useState([]);
  const [seguridadSociales, setSeguridadSociales] = useState([]);
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        // _ImssNominas,
        _seguroIMSS,
        _seguridadSociales,
      ] = await Promise.all([
        // getImssNominas(),
        getConfiguracionesSeguroIMSS(),
        getSeguridadsociales(),
      ]);
      if (mounted) {
        // setImssNominas(_ImssNominas?.results || []);
        setSeguroIMSS(_seguroIMSS);
        setSeguridadSociales(_seguridadSociales);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);
  const buscarConfig = (id) => seguroIMSS.find((item) => item.id === id) || {};

  const buscarSeguro = (id) => seguridadSociales.find((item) => item.id === id) || {};
  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'seguro_imss',
      key: 'clave',
      width: 120,
      render: (id) => buscarConfig(id)?.clave || '',
    },
    {
      titleText: 'Seguro',
      dataIndex: 'seguro_imss',
      key: 'seguro',
      width: 200,
      render: (id) => {
        const config = buscarConfig(id);
        const seguro = buscarSeguro(config?.seguro);
        return seguro?.nombre || '';
      },
    },
    {
      titleText: 'SBC',
      dataIndex: 'sbc',
      key: 'sbc',
      width: 120,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Base de Cálculo',
      dataIndex: 'base_de_calculo',
      key: 'base_de_calculo',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: '% Patrón',
      dataIndex: 'porcentaje_patron',
      key: 'porcentaje_patron',
      width: 150,
      align: 'right',
      render: (val) => percentFormatterNDecimals(val || 0),
    },
    {
      titleText: '% Trabajador',
      dataIndex: 'porcentaje_del_trabajador',
      key: 'porcentaje_del_trabajador',
      width: 150,
      align: 'right',
      render: (val) => percentFormatterNDecimals(val || 0),
    },
    {
      titleText: '% Total',
      dataIndex: 'porcentaje_total',
      key: 'porcentaje_total',
      width: 150,
      align: 'right',
      render: (val) => percentFormatterNDecimals(val || 0),
    },
    {
      titleText: 'Importe Patrón',
      dataIndex: 'importe_patron',
      key: 'importe_patron',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Trabajador',
      dataIndex: 'importe_trabajador',
      key: 'importe_trabajador',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: '$ Total',
      dataIndex: 'total',
      key: 'total',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          allowExportPDF={false}
        />
      </Spin>

    </Row>
  );
};

export default NominasIMSS;
